var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInviteGuest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.52 107.73C101.38 107.73 99.58 106.13 99.33 104.01L99.27 102.53C98.77 93.81 91.82 86.87 83.12 86.36L82.14 86.33H28.62C19.14 86.33 11.44 94.04 11.44 103.51C11.44 105.84 9.55 107.73 7.22 107.73C4.89 107.73 3 105.84 3 103.51C3 89.75 13.76 78.5 27.5 77.92L28.64 77.9H82.12C96.24 77.9 107.74 89.39 107.74 103.52C107.74 105.85 105.85 107.74 103.52 107.74V107.73ZM55.36 64.93C38.29 64.93 24.39 51.04 24.39 33.96C24.39 16.88 38.29 3 55.36 3C57.44 3 59.53 3.21 61.56 3.62C62.66 3.84 63.61 4.48 64.23 5.42C64.85 6.36 65.07 7.48 64.85 8.59C64.45 10.55 62.72 11.97 60.73 11.97C60.45 11.97 60.16 11.94 59.88 11.88C58.41 11.58 56.89 11.43 55.36 11.43C42.93 11.43 32.83 21.54 32.83 33.96C32.83 46.38 42.94 56.49 55.36 56.49C62.51 56.49 69.08 53.21 73.39 47.48C74.19 46.41 75.42 45.8 76.76 45.8C77.68 45.8 78.55 46.09 79.29 46.65C80.19 47.33 80.77 48.31 80.93 49.43C81.09 50.54 80.8 51.65 80.13 52.55C74.22 60.42 65.19 64.93 55.36 64.93ZM92.82 32.83C90.5 32.83 88.6 30.94 88.6 28.61V22.13H82.12C79.8 22.13 77.9 20.24 77.9 17.91C77.9 15.58 79.79 13.69 82.12 13.69H88.6V7.22C88.6 4.9 90.49 3 92.82 3C95.15 3 97.04 4.89 97.04 7.22V13.7H103.52C105.84 13.7 107.74 15.59 107.74 17.92C107.74 20.25 105.85 22.14 103.52 22.14H97.04V28.62C97.04 30.94 95.15 32.84 92.82 32.84V32.83Z",
    fill: "#636365"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteGuest);
export default __webpack_public_path__ + "static/media/inviteGuest.c5f31f31.svg";
export { ForwardRef as ReactComponent };